import React from "react"
import { css } from "@emotion/core"

const cardStyle = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
`

const titleStyle = css`
  margin: 0 0 12px;
  min-height: 2.7em;
  font-size: 18px;
  line-height: 1.35;

  @media (max-width: 768px) {
    min-height: 0;
  }
`

const frameStyle = css`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  background: #111;
`

const iframeStyle = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`

const fallbackStyle = css`
  display: inline-block;
  margin-top: 10px;
`

const getEmbedData = stateProps => {
  if (stateProps.provider === "facebook" && stateProps.url) {
    return {
      src: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        stateProps.url
      )}&show_text=false&width=560`,
      externalUrl: stateProps.url,
      allow:
        "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
    }
  }

  if (stateProps.provider === "youtube" && stateProps.videoId) {
    const startSeconds = Number.parseInt(stateProps.startSeconds, 10)
    const startQuery =
      Number.isFinite(startSeconds) && startSeconds > 0
        ? `?start=${startSeconds}`
        : ""
    const externalStartQuery =
      Number.isFinite(startSeconds) && startSeconds > 0
        ? `&t=${startSeconds}s`
        : ""

    return {
      src: `https://www.youtube-nocookie.com/embed/${encodeURIComponent(
        stateProps.videoId
      )}${startQuery}`,
      externalUrl: `https://www.youtube.com/watch?v=${encodeURIComponent(
        stateProps.videoId
      )}${externalStartQuery}`,
      allow:
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    }
  }

  return null
}

export const VideoEmbed = ({ stateProps, htmlProps }) => {
  const embed = getEmbedData(stateProps)

  if (!embed) {
    return (
      <div {...htmlProps}>
        <strong>{stateProps.title}</strong>
      </div>
    )
  }

  return (
    <article {...htmlProps} css={cardStyle}>
      <h3 css={titleStyle}>{stateProps.title}</h3>
      <div css={frameStyle}>
        <iframe
          css={iframeStyle}
          src={embed.src}
          title={stateProps.title}
          loading="lazy"
          allow={embed.allow}
          allowFullScreen
        />
      </div>
      {stateProps.fallbackLabel && (
        <a
          css={fallbackStyle}
          href={embed.externalUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {stateProps.fallbackLabel}
        </a>
      )}
    </article>
  )
}

VideoEmbed.displayName = "VideoEmbed"

export const VideoEmbedCanvas = VideoEmbed
VideoEmbedCanvas.displayName = "VideoEmbedCanvas"
